import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

export const SectionHeader = ({ icon, label }) => (
    <View
        style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 10,
        }}
    >
        <View
            style={{
                width: 26,
                height: 26,
                borderRadius: 13,
                backgroundColor: theme.colors.material.primary["50"],
                alignItems: "center",
                justifyContent: "center",
                marginRight: 8,
            }}
        >
            <FontAwesome5
                name={icon}
                size={12}
                color={theme.colors.primary}
                solid
            />
        </View>
        <TextM fontWeight="Bold" fontSize={14}>
            {label}
        </TextM>
    </View>
)
